
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as healthhjhBKGHaVE1dTDMiw3FgPGMOLbCc_45lB7LaJXVur3cZkMeta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_937FUTfy7oSy0X6K5PZtcRLRACtyXyv83X6Ps_IESwRp8Meta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue?macro=true";
import { default as port_45parkingYsKRcd4MtqnaoQCbQzp88n_FvPN0QKt_45CMPtGVpJDTIMeta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-parking.vue?macro=true";
import { default as airport_45hotels7f19DYjwHZ_45Bps3cybn_pA4XzFqKaJsmdoltPPy6UV4Meta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels.vue?macro=true";
import { default as airport_45parkingYafdRwc71BxmEZlz0GR9_45UYpe3ghA4dTahtyMfGHjkgMeta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93GVJTSTwdhjYxGj4L4cMhghDTTQ_67qks90GacqXQlL8Meta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hro/[code]-[name]-[IATA].vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93likolESuyJuN_5DtVbxtdBbRdVsN4YXfI4ImLrJKVHwMeta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/parking/[code]-[name]-[IATA].vue?macro=true";
import { default as port_45hotels_45with_45parkingAIqYyXzupH_45mEShNNXc8apljDNCT7S_j0jpGbS47vhIMeta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-hotels-with-parking.vue?macro=true";
import { default as airport_45hotels_45with_45parkingMF6dlj2QiHBA3DC2SIXnupx_45z1BpIOcY98xyaMzgcokMeta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels-with-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93BPSXuVZ95QLqUcKOHiF75LqCoaGxMEiQOQSY_OOqFzoMeta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hotel-package/[code]-[name]-[IATA].vue?macro=true";
import { default as component_45stubK9UhAgZXCT6TzgwDRzAxo92rezR5aL_45gpH2YZ8l4cCsMeta } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.17_db0@0.3.2_eslint@8.57.1_ioredis@_fa1753a218df0204c146e28a298f3f0e/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubK9UhAgZXCT6TzgwDRzAxo92rezR5aL_45gpH2YZ8l4cCs } from "/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.17_db0@0.3.2_eslint@8.57.1_ioredis@_fa1753a218df0204c146e28a298f3f0e/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue")
  },
  {
    name: "IATA-port-parking___en",
    path: "/:IATA()/port-parking",
    component: () => import("/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-parking.vue")
  },
  {
    name: "IATA-airport-hotels___en",
    path: "/:IATA()/airport-hotels",
    component: () => import("/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels.vue")
  },
  {
    name: "IATA-airport-parking___en",
    path: "/:IATA()/airport-parking",
    component: () => import("/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-parking.vue")
  },
  {
    name: "hro-code-name-IATA___en",
    path: "/hro/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hro/[code]-[name]-[IATA].vue")
  },
  {
    name: "parking-code-name-IATA___en",
    path: "/parking/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/parking/[code]-[name]-[IATA].vue")
  },
  {
    name: "IATA-port-hotels-with-parking___en",
    path: "/:IATA()/port-hotels-with-parking",
    component: () => import("/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-hotels-with-parking.vue")
  },
  {
    name: "IATA-airport-hotels-with-parking___en",
    path: "/:IATA()/airport-hotels-with-parking",
    component: () => import("/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels-with-parking.vue")
  },
  {
    name: "hotel-package-code-name-IATA___en",
    path: "/hotel-package/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src1387709666/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hotel-package/[code]-[name]-[IATA].vue")
  },
  {
    name: component_45stubK9UhAgZXCT6TzgwDRzAxo92rezR5aL_45gpH2YZ8l4cCsMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubK9UhAgZXCT6TzgwDRzAxo92rezR5aL_45gpH2YZ8l4cCs
  }
]